import { jwtClient } from "better-auth/client/plugins";
import {
  customSessionClient,
  emailOTPClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: `${import.meta.env.VITE_BACKEND_URL}/api/auth`,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [customSessionClient(), jwtClient(), emailOTPClient()],
});

type AuthSessionObject = typeof authClient.$Infer.Session;

export type CustomSession = {
  user: Omit<
    AuthSessionObject["user"],
    "id" | "createdAt" | "updatedAt" | "emailVerified"
  > & {
    userId: string;
    systemRole: string;
    accountingFirms: {
      accountingFirmId: string;
      accountingFirmName: string;
      role: string;
    }[];
    createdAt?: Date;
    updatedAt?: Date;
    emailVerified?: boolean;
  };
  session: AuthSessionObject["session"];
};

export function useSession() {
  const session = authClient.useSession();

  return session as typeof session & { data: CustomSession | null };
}
